export default __webpack_public_path__ + "static/media/arrow_left_ckb.c428c4be.svg";